import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getFocusAreas} from '../actions/MainAction';
export class FocusAreasPage extends Component {
  
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            text:lang?.text?lang?.text:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getFocusAreas,
        afterParams:[],
        url:'admin-focus-areas'
      }
    })
  }

  componentDidMount(){
    this.props.getFocusAreas();
  }
  render() {
    const {focusAreasData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="Focus Areas" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            focusAreasData?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  video={data?.video_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-focus-areas/${data?.id}`}
                  afterCallFunction={()=> this.props.getFocusAreas()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  focusAreasData: state.Data.focusAreasData,
});
const mapDispatchToProps = {changeStateValue, getFocusAreas}
export default connect(mapStateToProps, mapDispatchToProps)(FocusAreasPage)
 
 
